<template>
  <div class="map-page">
    <MapCreate
      class="map"
      @changeAddress="address = $event"
      @changeCoords="coords = $event"
      @pick="onPick"
    />

    <div
      v-if="address || coords.length"
      class="address"
    >
      <div class="address__icon-wrapper">
        <BaseIcon icon="pin" />
      </div>
      <BaseInput
        ref="address"
        class="address__text"
        v-model="address"
      />

      <div class="address__coords">{{ coords }}</div>
    </div>

    <div class="panel">
      <BaseButton @click="onNext">
        ДАЛЕЕ
      </BaseButton>
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/Base/BaseInput'
import BaseButton from '@/components/Base/BaseButton'
import BaseIcon from '@/components/Base/BaseIcon'
import MapCreate from './MapCreate'

export default {
  name: 'AppMap',
  components: {
    BaseInput,
    BaseButton,
    BaseIcon,
    MapCreate
  },
  computed: {
    address: {
      get () {
        return this.$store.state.createField.mapStep.address
      },
      set (value) {
        this.$store.state.createField.mapStep.address = value
      }
    },
    coords: {
      get () {
        return this.$store.state.createField.mapStep.coords
      },
      set (value) {
        this.$store.state.createField.mapStep.coords = value
      }
    }
  },
  methods: {
    onNext () {
      if (!this.address || !this.coords) {
        return
      }
      this.$emit('next')
    },
    onPick (coords) {
      this.address = ''
      this.coords = coords

      this.$nextTick(() => {
        this.$refs.address.$el.focus()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.map-page {
  .map {
    width: 100%;
    height: 100%;
    min-height: 800px;
  }

  .address {
    display: flex;
    align-items: center;
    margin-top: 25px;

    &__icon-wrapper {
      color: $brand-color;
    }

    &__text {
      max-width: 300px;
      margin-left: 12px;
    }

    &__coords {
      cursor: default;
      color: #A1A1A8;
      padding: 10px 16px;
      background: #242428;
      border-radius: 10px;
      margin-left: 24px;
    }
  }

  .panel {
    margin-top: 30px;
    text-align: right;
  }
}
</style>
